/*
 * Copyright (c) 2023. RoZetta Technology Pty Ltd. All rights reserved.
 */

import { MenuProps, Theme } from "@mui/material";
import { createTheme } from "@mui/material/styles";

import basicThemePalette from "./Palette";

export const menuAnchorProps: Partial<MenuProps> = {
	anchorOrigin: {
		vertical: "bottom",
		horizontal: "left",
	},
	transformOrigin: {
		vertical: "top",
		horizontal: "left",
	},
};

const IATheme: Theme = createTheme({
	palette: basicThemePalette,
	typography: {
		fontFamily: "ProximaNova",
		h1: {
			fontFamily: "ProximaNova-Bold",
			fontSize: 30,
		},
		h2: {
			fontFamily: "ProximaNova",
			fontSize: 30,
		},
		h3: {
			fontFamily: "ProximaNova-Bold",
			fontSize: 17,
		},
		h4: {
			fontSize: 17,
		},
		h5: {
			fontFamily: "ProximaNova-Bold",
			fontSize: 25,
		},
		h6: {
			fontFamily: "ProximaNova-Bold",
			fontSize: 14,
		},
		subtitle1: {
			fontFamily: "ProximaNova-Bold",
			fontSize: 14,
		},
		subtitle2: {
			fontSize: 10,
		}
	},
	components: {
		MuiCssBaseline: {
			styleOverrides: `
        @font-face {
          font-family: 'ProximaNova';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
		},
		MuiToolbar: {
			styleOverrides: {
				regular: {
					minHeight: 48,
					"@media (min-width: 600px)": {
						minHeight: 48,
					},
				},
			},
		},
		MuiTooltip: {
			styleOverrides: {
				tooltip: {
					fontSize: 14,
				},
			},
		},
		MuiInputLabel: {
			styleOverrides: {
				outlined: {
					backgroundColor: basicThemePalette.background?.default ?? "#131e29",
					paddingLeft: 2,
					paddingRight: 2
				},
			},
		},
		MuiTextField: {
			defaultProps: {
				SelectProps: {
					MenuProps: menuAnchorProps,
				},
			},
		},
		MuiSelect: {
			defaultProps: {
				MenuProps: menuAnchorProps,
			},
		},
	},
});

export default IATheme;
